/// <reference lib="dom" />
import * as d3 from "d3";
import { type Chart, type ChartLayer, CreateChart } from "../../core/chart.ts";
import {
  type ChartMode,
  EditorSize,
  InlineSize,
  ModeSize,
  ModeTheme,
  PadMargin,
} from "../../core/mode.ts";
import { LinesLayer } from "../../layers/lines.ts";
import type { ChartTheme } from "../../utils/theme.ts";

export const TransferEditorSize = EditorSize(10, 6);
export const TransferInlineSize = { ...InlineSize, pad: 2 };

export interface TransferChartOpts {
  mode: ChartMode;
  domain: [number, number];
  layers: ChartLayer[];
  theme?: ChartTheme;
}

export function CreateTransferChart(container: HTMLElement, opts: TransferChartOpts): Chart {
  const size = ModeSize(opts.mode, TransferEditorSize, TransferInlineSize);
  const theme = ModeTheme(opts.mode, opts.theme);
  const unity = LinesLayer({ id: "unity" });
  const [min, max] = opts.domain;
  unity.set([
    {
      id: "unity",
      color: theme.refLine,
      width: opts.mode === "editor" ? 1 : 0.5,
      points: [{ x: min, y: min }, { x: max, y: max }],
    },
  ]);
  return CreateChart(container, {
    width: size.width,
    height: size.height,
    margin: PadMargin(size.pad),
    x: d3.scaleLinear().domain(opts.domain),
    y: d3.scaleLinear().domain(opts.domain),
    theme,
    layers: [unity, ...opts.layers],
  });
}
